import axiosInstance, { getApiUrl, ApiKeys, logError } from '@cp/src/utils/ApiHelper';
import { getFileDownload } from '@cp/src/utils/commonUtils';
import { Dispatch } from 'react';
import { setUploadHistory } from '../reducers/uploadHistorySlice';

export const fetchUploadHistory = (pageNo: number, pageSize: number, type?: string) => {
  const url = getApiUrl(ApiKeys.USER_UPLOAD_HISTORY);
  return (dispatch: Dispatch<any>) => {
    axiosInstance
      .get(url, {
        params: { pageNo, pageSize, type }
      })
      .then(response => {
        if (response) {
          dispatch(setUploadHistory(response?.data));
        }
      })
      .catch(error => {
        logError(error, 'Error inside fetchUploadHistory');
      });
  };
};

export const fetchUploadHistoryPolling = (pageNo: number, pageSize: number, type?: string) => {
  const url = getApiUrl(ApiKeys.USER_UPLOAD_HISTORY);
  return axiosInstance.get(url, {
    params: { pageNo, pageSize, type }
  });
};

export const fetchFailureReportFile = (fileReferenceId: string) => {
  const url = getApiUrl(ApiKeys.DOWNLOAD_FAILURE_REPORT, { fileReferenceId: fileReferenceId });
  return axiosInstance
    .get(url, {
      responseType: 'blob'
    })
    .then(response => {
      const type = response.headers['content-type'];
      const contentDisposition: string = response.headers['content-disposition'];
      const fileName = contentDisposition.replace('attachment; filename=', '');
      const blob = new Blob([response.data], { type });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    });
};

export const fetchFile = (fileReferenceId: string) => {
  const url = getApiUrl(ApiKeys.DOWNLOAD_ORIGINAL_FILE, { fileReferenceId: fileReferenceId });
  return axiosInstance.get(url).then(response => {
    const fileUrl = response?.data;
    getFileDownload(fileUrl);
  });
};

export const fetchNdraFailureFile = (fileReferenceId: string) => {
  const url = getApiUrl(ApiKeys.DOWNLOAD_NDRA_FAILURE_FILE, { referenceId: fileReferenceId });
  return axiosInstance.get(url).then(response => {
    const fileUrl = response?.data;
    getFileDownload(fileUrl);
  });
};
